const localStorage: any = {
    exist,
    get,
    set,
    remove,
    clear,
};

export default localStorage;

function exist(key: string): boolean {
    return window.localStorage.getItem(key) != null;
}

function get(key: string): any {
    if (!exist(key)) {
        return null;
    }

    const data: any = window.localStorage.getItem(key);

    return JSON.parse(data);
}

function set(key: string, data: any) {
    window.localStorage.setItem(key, JSON.stringify(data));
}

function remove(key: string) {
    window.localStorage.removeItem(key);
}

function clear(key: string) {
    window.localStorage.clear();
}
